import React from 'react'
import { StyleSheet, css } from 'aphrodite'
import { useTranslation } from 'react-i18next'
import UITitle from '../../../components/UI/UITitle'
import UISubtitle from '../../../components/UI/UISubtitle'
import LayoutRow from '../../../components/Layout/LayoutRow'
import LayoutCol from '../../../components/Layout/LayoutCol'
import { COLOR_ERROR, COLOR_GREEN__DARK } from '../../../lib/colors'
import { SPACE } from '../../../lib/spaces'
import IconCheck from '../../../components/Icon/IconCheck'
import { BP_XS, MEDIA_MIN_SM } from '../../../lib/breakpoints'
import { WIDTH } from '../../../lib/helpers'
import UIButton from './../../../components/UI/UIButton'

const styles = StyleSheet.create({
  container: {
    margin: 0,
    paddingBottom: SPACE * 10,
  },
  containerForm: {
    display: 'flex',
    flexDirection: 'Column',
    width: '100%',
  },
  noMargin: {
    margin: 0,
    padding: 0,
  },
  message: {
    fontWeight: 400,
    fontSize: 12,
  },
  errorMessage: {
    color: COLOR_ERROR,
  },
  submitButton: {
    display: 'flex',
    justifyContent: 'flex-end',
  },
  title: {
    color: COLOR_GREEN__DARK,
  },
  pleaseWait: {
    fontSize: 20,
    fontWeight: 700,
    textAlign: 'center',
    margin: '50px 0 90px 0',
  },
  center: {
    textAlign: 'center',
  },
  list: {
    display: 'flex',
    flexDirection: 'row',
    listStyle: 'none',
    alignItems: 'center',
  },
  iconCheck: {
    marginRight: 30,
    width: 24,
    height: 24,
  },
  space: {
    marginTop: 80,
  },
  containerList: {
    padding: 0,
    marginTop: 50,
    [MEDIA_MIN_SM]: {
      marginTop: 80,
      paddingLeft: 40,
    },
  },
  text: {
    fontSize: 16,
    fontWeight: 700,
    width: '65vw',
    [MEDIA_MIN_SM]: {
      fontSize: 20,
    },
  },
  btnWidth: {
    marginTop: '8vh',
    width: 315,
    marginBottom: '8vh',
  },
  textCenterItalic: {
    fontStyle: 'italic',
    textAlign: 'center',
  },
})

export const Waiting = () => {
  const { t } = useTranslation('translation')

  return (
    <LayoutRow>
      <LayoutCol col={WIDTH <= BP_XS ? 10 : 8} dynamicStyle={styles.container}>
        <UITitle
          dynamicStyle={styles.title}
          label={t('pages.registerMaker.waiting.title')}
        />
        <p>
          {t('pages.registerMaker.waiting.description1')}
          <br />
          {t('pages.registerMaker.waiting.description2')}
        </p>
        <p className={css(styles.pleaseWait)}>
          {t('pages.registerMaker.waiting.pleaseWait')}
        </p>
        <UISubtitle
          dynamicStyle={styles.center}
          size="large"
          label={t('pages.registerMaker.waiting.youMustHaveSendFile')}
        />
        <LayoutRow>
          <div className={css(styles.btnWidth)}>
            <UIButton
              fullWidth
              design="primary"
              kind="button"
              label={`${t('common.button.sendFile')}`}
              onClick={() => {
                window.open(
                  'https://app.provigis.com/',
                  '_blank',
                  'noopener,noreferrer'
                )
              }}
            />
            <p className={css(styles.textCenterItalic)}>
              {t('pages.registerMaker.waiting.redirectPartner')}
            </p>
          </div>
        </LayoutRow>
        <UISubtitle
          dynamicStyle={styles.center}
          size="large"
          label={t('pages.registerMaker.waiting.youMustHaveCertainEquipment')}
        />
        <ul className={css(styles.containerList)}>
          <li className={css(styles.list)}>
            <IconCheck dynamicStyle={styles.iconCheck}></IconCheck>
            <p className={css(styles.text)}>
              {t('pages.registerMaker.waiting.battery')}
            </p>
          </li>
          <li className={css(styles.list)}>
            <IconCheck dynamicStyle={styles.iconCheck}></IconCheck>
            <p className={css(styles.text)}>
              {t('pages.registerMaker.waiting.device')}
            </p>
          </li>
          <li className={css(styles.list)}>
            <IconCheck dynamicStyle={styles.iconCheck}></IconCheck>
            <p className={css(styles.text)}>
              {t('pages.registerMaker.waiting.headphones')}
            </p>
          </li>
          <li className={css(styles.list)}>
            <IconCheck dynamicStyle={styles.iconCheck}></IconCheck>
            <p className={css(styles.text)}>
              {t('pages.registerMaker.waiting.jacket')}
            </p>
          </li>
        </ul>
      </LayoutCol>
    </LayoutRow>
  )
}
